<template lang="pug">
    .footer(ref='footer')
      .container.pt-4
        .row
          .col-md-3.text-left
            img.icon(src="https://cdn.wallcollective.co/resources/branding/logo_co_dark.svg", alt="Wall collective logo")
            ul.p-0.text-dark.py-3(style="list-style-type:none")
              li.link
                a.m-2(href="https://www.instagram.com/wall_collective/")
                  i.fab.fa-instagram
          .col-6.col-md-3.text-left
            h3.mt-0 Quick Links
            ul.p-0.text-dark.py-3.footer-nav(style="list-style-type:none")
              li.link.d-block
                router-link(:to="{name:'gallery'}") ARTWORKS
              li.link.d-block
                router-link(:to="{name:'artists'}") ARTISTS
              li.link.d-block
                router-link(:to="{name:'rentals'}") CONSULTING & CURATION
              li.link.d-block
                router-link(:to="{name:'rentals'}") RENTALS
              li.link.d-block
                router-link(:to="{name:'about'}") ABOUT US
          .col-6.col-md-3.text-left
            h3.mt-0 Login
            ul.p-0.text-dark.py-3.footer-nav(style="list-style-type:none")
              li.link.d-block
                router-link(:to="{name:'login'}") AS ARTIST
              li.link.d-block
                router-link(:to="{name:'login'}") AS COLLECTOR
          .col-6.col-md-3.text-left
            h3.mt-0 Contact
            ul.p-0.text-dark.py-3.footer-nav(style="list-style-type:none")
              li.link.d-block
                router-link(:to="{name:'contact'}") info@wallcollective.co
              li.link.d-block
                router-link(:to="{name:'contact'}") +27 72 457 2525
              li.link.d-block
                router-link(:to="{name:'contact'}") Stellenbosch, South Africa
</template>

<script>

export default {
  name: 'FooterSection',
  components: {
  },
};
</script>

<style lang="scss" scoped>

  .footer{
    position: relative;
    padding: 20px 0 20px 0 !important;
    ul {
      li {
        display: inline-block;
        margin: 0 0 2px 0;
        font-size: 14px;
      // @include phone {
      //   padding: 1.5rem 0;
      // }
      }
    }
    .icon{
      width: 70%;
      max-width: 100px;
    }
    @include phone {
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/structure/FooterStandard.vue